<template>
    <div>
        <div v-html="inform" class="html"></div>
    </div>
</template>
<style lang="scss" scoped>
.html{
   margin: 10px;
}
</style>
<script>
import {newIntrduction,interRule } from '@api/user';
export default {
    name:'goods',
    data(){
        return{
            inform:''
        }
    },
    mounted(){
        if (this.$route.query.token && this.$route.query.token.length > 0) {
            let time = this.$route.query.expires_time || "";
            let token = this.$route.query.token || "";
            console.log(time);
            const datas = {
                token: token,
                expires_time: time,
            };
            this.$store.commit("LOGIN", datas);
        }
        console.log("id=====>",this.$route.query.id)
        if(this.$route.query.id==4){
            interRule().then(res=>{
                console.log("success=>",res)
            this.inform=res.msg.replace(/<img/g,"<img style='max-width:100%;height:auto;'");
            }).catch(err=>{
                console.log("err=>",err)
            })
            return
        }
        let data={
            id:this.$route.query.id
        }
        newIntrduction(data).then(res=>{
             console.log("success=>",res)
            this.inform=res.msg.replace(/<img/g,"<img style='max-width:100%;height:auto;'");
        }).catch(err=>{
            console.log(err)
        })
    }
}
</script>